// extracted by mini-css-extract-plugin
module.exports = {"heading":"about-module--heading--2_4E-","content":"about-module--content--1y3Xq","certificationList":"about-module--certification-list--1PNCl"};